import type { PagesMenu } from "~/types/pagesMenu";
import rotinasConsulta from "~/composables/menus/rotinas/consulta/rotinas";

/**
 * Rótulo da categoria "B4 - Consultas".
 *
 * Vive aqui porque três lugares dependem dele casando exatamente: a declaração
 * das rotinas (`rotinas.ts`), o laço que distribui rotina por categoria
 * (`useSetMenusCollector`) e quem lê essa categoria de volta do store. Escrever
 * a string à mão em cada um faz a seção sumir em silêncio quando um diverge.
 */
export const CATEGORIA_CONSULTA = "Consulta";

export default function () {
	return rotinasConsulta;
}

/**
 * Consultas que o usuário logado pode abrir.
 *
 * Lê a categoria já montada no store, então a permissão continua aplicada num
 * lugar só (`definirRotinasDisponiveis`, contra `ACEUSU_ID_MENU_PF`): aqui não
 * há regra de acesso, só leitura.
 *
 * As consultas saíram da grade do menu e viraram o botão de lupa do topo — a
 * lista é a mesma, o lugar é que mudou.
 */
export function useConsultasLiberadas() {
	const userStore = useUserStore();

	return computed<PagesMenu["items"]>(() => {
		const categoria = (userStore.userRoutines as PagesMenu[])
			.find(menu => menu.label === CATEGORIA_CONSULTA);

		return (categoria?.items ?? []).filter(item => item.visible !== false);
	});
}
